import { useQuery } from "@tanstack/react-query"
import { Link } from "react-router-dom"
import { recoveryCall, type RecoveryContact } from "@/api/recovery"
import { APP_ROUTES } from "@/common/urls"
import { Alert, AlertTitle } from "@/components/ui/alert"

export function RecoveryContactPrompt() {
    const status = useQuery({
        queryKey: ["recoveryContact"],
        queryFn: () => recoveryCall<RecoveryContact>("getRecoveryContact"),
    })
    if (!status.data || status.data.verified) return null
    return (
        <Alert variant="warning">
            <AlertTitle>Verify your recovery contact</AlertTitle>
            <p className="text-sm mt-2">
                {status.data.email
                    ? "Your saved secondary email is not yet verified."
                    : "Add an authorised recovery contact."}{" "}
                This helps CMHT restore access if your primary inbox becomes
                unavailable.{" "}
                <Link
                    className="underline font-medium"
                    to={APP_ROUTES.ROOT.ACCOUNT}
                >
                    Review your account
                </Link>
            </p>
        </Alert>
    )
}
